
import { CLIENT_ID,REDIRECT_URL } from "../environments";
export const msalConfig = {
  auth: {
    // clientId: "f5caf859-763e-43ef-b2e2-e81229a68d0e",
    clientId:CLIENT_ID,
    authority:
      "https://login.microsoftonline.com/5e45e2ef-d6aa-4ad1-aaca-a7187394a753",
      //redirectUri: "https://devopssrescoreportal.sandhata.com/admin-login"
     redirectUri: REDIRECT_URL,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
